import { avatarColor, initials } from "@/lib/format";
import type { Channel } from "@/lib/types";
import { ChannelBadge } from "./ChannelBadge";

export interface AvatarProps {
  name?: string | null;
  email?: string | null;
  /** Profile image URL; falls back to coloured initials when absent. */
  src?: string | null;
  channel?: Channel;
  size?: number;
  online?: boolean;
}

export function Avatar({ name, email, src, channel, size = 36, online }: AvatarProps) {
  const seed = name || email || "?";
  const label = initials(name, email);
  const badgeSize = Math.max(12, Math.round(size * 0.42));
  const dotSize = Math.max(8, Math.round(size * 0.28));

  return (
    <span className="relative inline-flex shrink-0" style={{ width: size, height: size }}>
      {src ? (
        <img src={src} alt={label} className="rounded-full object-cover" style={{ width: size, height: size }} />
      ) : (
        <span
          className="flex items-center justify-center rounded-full font-semibold text-white"
          style={{
            width: size,
            height: size,
            backgroundColor: avatarColor(seed),
            fontSize: Math.round(size * 0.4),
          }}
        >
          {label}
        </span>
      )}
      {channel ? (
        <span className="absolute -bottom-0.5 -right-0.5 rounded-full ring-2 ring-bg">
          <ChannelBadge channel={channel} size={badgeSize} />
        </span>
      ) : online ? (
        <span
          className="absolute bottom-0 right-0 rounded-full bg-success-dot ring-2 ring-bg"
          style={{ width: dotSize, height: dotSize }}
        />
      ) : null}
    </span>
  );
}
